import { useMemo } from 'react';
import { UNITE_SUMMARIZATION_AND_KEYWORDS } from '@rsos/capstone/src/constants/capabilities';
import useHasCapability from '@rsos/hooks/useHasCapability';
import useHasPermission from '@rsos/hooks/useHasPermission';
import { UNITE_SUMMARIZATION_AND_KEYWORDS_PERMISSION } from '../constants/permissions';

const useHasAccessToSummarizationAndKeywords = () => {
  const hasUnitedSummarizationAndKeywordsCapabilities = useHasCapability(
    UNITE_SUMMARIZATION_AND_KEYWORDS,
  );
  const hasUniteSummarizationAndKeywordsPermission = useHasPermission(
    UNITE_SUMMARIZATION_AND_KEYWORDS_PERMISSION,
  );
  const hasAccessToSummarizationAndKeywordsFeature = useMemo(() => {
    return (
      !!hasUnitedSummarizationAndKeywordsCapabilities?.hasCapability &&
      !!hasUniteSummarizationAndKeywordsPermission?.hasPermission
    );
  }, [
    hasUnitedSummarizationAndKeywordsCapabilities,
    hasUniteSummarizationAndKeywordsPermission,
  ]);

  return hasAccessToSummarizationAndKeywordsFeature;
};

export default useHasAccessToSummarizationAndKeywords;
